import { type Dispatch, type SetStateAction, useEffect } from "react";

import useCrmLeads from "../../../../../datahooks/useCrmLeads";
import CsvOverview from "../CsvOverview";

import type { CsvState } from "../../../../../types";

import InstantlyLoader from "assets/images/instantly-in-progress.png";

interface CrmLeadsProps {
  isFileError: boolean;
  csvState: CsvState;
  setCsvState: Dispatch<SetStateAction<CsvState>>;
  targetingSource: { id: string; name: string };
  urlVariable?: string;
  onBack: () => void;
}

export default function CrmLeads({
  targetingSource,
  urlVariable,
  isFileError,
  csvState,
  setCsvState,
  onBack,
}: CrmLeadsProps) {
  const { crmLeadsState, isLoadingCrmLeadsState } = useCrmLeads(
    targetingSource.id,
    urlVariable,
  );

  const { state, leads } = crmLeadsState ?? {};

  useEffect(() => {
    if (state === "success" && leads) {
      setCsvState({
        ...leads,
        fileName: targetingSource.name,
        mainIdentifier: leads.url_columns?.[0] ?? "",
      });
    }
  }, [state, targetingSource.id]);

  const isLoading =
    isLoadingCrmLeadsState || !csvState || state === "in_progress";

  // TODO: Handle failed state
  if (state === "failed") return;

  if (isLoading)
    return (
      <section className="mx-auto flex w-full max-w-[717px] flex-col items-center lg:rounded-5xl lg:border lg:border-black-200 lg:px-5 lg:py-10 lg:shadow-md">
        <img
          src={InstantlyLoader}
          width={384}
          height={187}
          className="mb-6"
          alt="Parsing list"
        />
        <h3 className="text-center text-2xl-bold mb-2">Uploading source...</h3>
        <p className="text-black-500 text-sm text-center">
          We are parsing your selected targeting source. This can take up to a
          minute
        </p>
      </section>
    );

  return (
    <CsvOverview
      csvState={csvState}
      setCsvState={setCsvState}
      isFileError={isFileError}
      onChange={onBack}
      isInstantly
    />
  );
}
